<template>
    <div class="statistics">
        <div class="condition">
            <div class="condition__group">
                <el-date-picker
                    v-model="countTime"
                    :editable="false"
                    :picker-options="pickerOptions"
                    @change="onChangeDate"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    popper-class="condition__popup--date"
                    class="condition__group--date"
                ></el-date-picker>
                <el-select
                    v-model="cooperative"
                    filterable
                    clearable
                    @change="onChangeCooperative"
                    placeholder="请选择合作社"
                    popper-class="condition__popup--select"
                    class="condition__group--select"
                >
                    <el-option
                        v-for="item of cooperativeOptions"
                        :key="item.value"
                        :label="item.cooperativeName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
                <el-select
                    v-model="owner"
                    filterable
                    clearable
                    @change="onChangeOwner"
                    placeholder="请选择农机主"
                    popper-class="condition__popup--select"
                    class="condition__group--select"
                >
                    <el-option
                        v-for="item of ownerOptions"
                        :key="item.value"
                        :label="item.farmName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
                <el-select
                    v-model="town"
                    filterable
                    clearable
                    @change="onChangeTown"
                    placeholder="请选择地址"
                    popper-class="condition__popup--select"
                    class="condition__group--select"
                >
                    <el-option
                        v-for="item of townOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div>
            <el-button
                @click="handleQuery"
                type="primary"
                class="condition--btn"
                >查询</el-button
            >
        </div>
        <table-info
            :columns="statisticsColumns"
            :table-data="statisticsData"
            :limitMoveNum="notScroll"
        />
        <el-pagination
            v-if="statisticsData.length"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.currentPage"
            :page-sizes="page.pageSizes"
            :page-size="page.pageSize"
            :total="page.total"
            layout="prev, pager, next, total, sizes, jumper"
            popper-class="page--popup"
        >
        </el-pagination>
    </div>
</template>
<script>
import TableInfo from '@/components/TableInfo'
import * as largeScreenAPI from '@/api/large-screen'
import { formatDate, getBeforeDate } from '@/utils/index'

export default {
    components: { TableInfo },
    data() {
        return {
            id: this.$route.query.id,
            statisticsColumns: [
                { title: '序号', field: 'id', width: '10%' },
                { title: '合作社', field: 'cooperativeName' },
                { title: '农机主', field: 'ownerName' },
                { title: '乡镇地址', field: 'townName' },
                { title: '农机车牌号', field: 'plateNumber', width: '12%' },
                { title: '作业地点', field: 'address' },
                { title: '作业类型', field: 'jobType', width: '10%' },
                { title: '农机类型', field: 'machineType', width: '10%' },
                { title: '作业面积（亩）', field: 'jobArea', width: '15%' },
                { title: '作业深度（厘米）', field: 'averDeep', width: '16%' },
                { title: '作业时间', field: 'startEndTime' },
                { title: '数据来源平台', field: 'datsSource', width: '15%' }
            ],
            statisticsData: [],
            page: {
                total: 0,
                pageSizes: [20, 50, 80, 100],
                pageSize: 20,
                currentPage: 1
            },
            condition: {
                townId: undefined,
                ownerId: undefined,
                cooperativeId: undefined,
                jobBeginTime: getBeforeDate(
                    29,
                    formatDate(new Date(), { type: 'date' })
                ),
                jobEndTime: formatDate(new Date(), { type: 'date' })
            },
            countTime: [
                getBeforeDate(29, formatDate(new Date(), { type: 'date' })),
                formatDate(new Date(), { type: 'date' })
            ],
            selectDate: '',
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.selectDate = minDate.getTime()
                    if (maxDate) {
                        this.selectDate = ''
                    }
                },
                disabledDate: (time) => {
                    var isSelected = false
                    if (this.selectDate !== '') {
                        const minTime = this.selectDate - 30 * 24 * 3600 * 1000
                        const maxTime =
                            this.selectDate + (30 - 1) * 24 * 3600 * 1000
                        isSelected =
                            time.getTime() <= minTime ||
                            time.getTime() > maxTime
                    }
                    return (
                        isSelected ||
                        time.getTime() > Date.now() - 8.64e6 ||
                        time.getTime() < new Date('2021-01-01') - 8.64e7
                    )
                }
            },
            cooperative: '',
            cooperativeOptions: [],
            owner: '',
            ownerOptions: [],
            town: '',
            townOptions: [],
            notScroll: 101 // 大于 pageSizes 中最大的数就是禁止滚动
        }
    },
    methods: {
        async getStatisticsList() {
            const {
                page,
                id,
                condition: {
                    townId,
                    ownerId,
                    cooperativeId,
                    jobBeginTime,
                    jobEndTime
                }
            } = this
            const params = {
                page: page.currentPage,
                size: page.pageSize,
                locId: id,
                townId: townId,
                ownerId: ownerId,
                cooperativeId: cooperativeId,
                jobBeginTime: jobBeginTime,
                jobEndTime: jobEndTime
            }
            const response = await largeScreenAPI.getJobStatisticsCount(params)
            if (response && response.data) {
                this.page.total = response.data.total
                this.statisticsData = response.data.list
                this.statisticsData.forEach((item) => {
                    item.startEndTime = `${item.jobStartTime}/${item.jobEndTime}`
                })
            }
        },
        async getCooperativeOptions() {
            const { id } = this
            const response = await largeScreenAPI.getCooperativeOptions(id)
            if (response.data.length) {
                this.cooperativeOptions = response.data
            }
        },
        async getOwnerOptions() {
            const { id } = this
            const response = await largeScreenAPI.getOwnerOptions(id)
            if (response.data.length) {
                this.ownerOptions = response.data
            }
        },
        async getTownOptions() {
            const { id } = this
            const response = await largeScreenAPI.getTownOptions(id)
            if (response.data.length) {
                this.townOptions = response.data
            }
        },
        handleSizeChange(pageSize) {
            this.page.pageSize = pageSize
            this.page.currentPage = 1

            this.getStatisticsList()
        },
        handleCurrentChange(page) {
            this.page.currentPage = page

            this.getStatisticsList()
        },
        handleQuery() {
            this.page.currentPage = 1
            this.getStatisticsList()
        },
        onChangeDate(time) {
            this.condition.jobBeginTime = time ? time[0] : ''
            this.condition.jobEndTime = time ? time[1] : ''
        },
        onChangeCooperative(cooperative) {
            this.condition.cooperativeId = cooperative
        },
        onChangeOwner(owner) {
            this.condition.ownerId = owner
        },
        onChangeTown(town) {
            this.condition.townId = town
        }
    },
    mounted() {
        this.getCooperativeOptions()
        this.getOwnerOptions()
        this.getTownOptions()
        this.getStatisticsList()
    }
}
</script>
<style lang="scss" scoped>
.statistics {
    width: calc(100% - 32px);
    height: calc(100% - 30px);
    background-image: url('../../assets/images/appointment-box.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 21px 15px 11px 15px;
    display: block !important;
    ::-webkit-scrollbar {
        width: 9px;
        height: 9px;
    }
    ::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0);
        border-radius: 4px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #94a2b4;
        border-radius: 4px;
    }
    .condition {
        width: calc(100% - 16px);
        height: 46px;
        line-height: 46px;
        margin: 0 8px 20px 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &--btn {
            width: 134px;
            text-align: center;
            font-size: 16px;
            letter-spacing: 5px;
        }
    }
    .table-info {
        height: auto;
        ::v-deep {
            .header {
                height: 55px;
                line-height: 55px;
                padding-right: 10px;
            }
            .list {
                max-height: 749px;
                height: auto;
                overflow: auto;
                margin: 14px 0;
                .item {
                    height: 55px;
                    margin-bottom: 16px;
                    padding: 0;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .text {
                        font-size: 16px;
                    }
                }
            }
        }
    }
    .el-pagination {
        text-align: center;
        ::v-deep {
            button {
                background: none;
                color: #fff;
                padding: 0 5px;
                &:disabled {
                    opacity: 0.2;
                }
            }
            .el-pager {
                li {
                    min-width: 30px;
                    height: 30px;
                    line-height: 30px;
                    background-color: rgba(144, 219, 255, 0.5);
                    color: #fff;
                    border-radius: 2.2px;
                    margin: 0 5px;
                    font-weight: normal;
                    &.active {
                        background-color: #00bfff;
                        color: #02070f;
                    }
                }
            }
            .el-pagination__total {
                color: #fff;
            }
            .el-input {
                margin: 0;
                .el-input__inner {
                    background: none;
                    border: none;
                    color: #fff;
                }
            }
            .el-pagination__jump {
                margin: -1px 0 0 0;
                color: #fff;
                .el-input__inner {
                    width: 30px;
                    height: 30px;
                    line-height: 30px;
                    background-color: rgba(144, 219, 255, 0.5);
                    color: #fff;
                }
            }
        }
    }
}
</style>
<style lang="scss"></style>
